module.exports = __webpack_public_path__ + "static/media/quinoa.7c9d3867.png";